import { Ability, type RawRuleOf, type AbilityClass } from '@casl/ability'
import { initialAbility } from './initialAbility'

type AppAbility = Ability<[string, string]>
const AppAbilityClass = Ability as AbilityClass<AppAbility>

const readStoredAbility = (): RawRuleOf<AppAbility>[] | null => {
  try {
    const userData = JSON.parse(localStorage.getItem('userData') ?? '{}')
    const rules = userData?.ability
    return Array.isArray(rules) && rules.length > 0 ? rules : null
  } catch {
    return null
  }
}

const ability = new AppAbilityClass(readStoredAbility() || initialAbility)

export const syncAbility = (rules?: RawRuleOf<AppAbility>[] | null): void => {
  const nextRules =
    Array.isArray(rules) && rules.length > 0 ? rules : initialAbility
  ability.update(nextRules)
}

export default ability
